const s = {
  name: "Rosetta",
  dimensions: { width: 31, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 31 40.1" style="enable-background:new 0 0 31 40.1;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9,33.1H5v2h4V33.1z"/>
		<path class="st0" d="M11,35.1v-2h8v2H11z"/>
		<path class="st0" d="M16,29.1H5v2h11V29.1z"/>
		<path class="st0" d="M18,29.1h7v2h-7V29.1z"/>
		<path class="st0" d="M26,25.1H13v2h13V25.1z"/>
		<path class="st0" d="M5,25.1h6v2H5V25.1z"/>
		<path class="st0" d="M26,21.1H15v2h11V21.1z"/>
		<path class="st0" d="M5,21.1h8v2H5V21.1z"/>
		<path class="st0" d="M25,17.1h-3v2h3V17.1z"/>
		<path class="st0" d="M5,17.1h15v2H5V17.1z"/>
		<path class="st0" d="M23,13.1h-8v2h8V13.1z"/>
		<path class="st0" d="M5,13.1h8v2H5V13.1z"/>
		<path class="st0" d="M16,9.1h-6v2h6V9.1z"/>
		<path class="st0" d="M18,9.1h4v2h-4V9.1z"/>
		<path class="st0" d="M23,5.1h-6v2h6V5.1z"/>
		<path class="st0" d="M27,6c0-4.4-4.6-7.3-8.6-5.4L2.8,8.1C1.1,8.9,0,10.7,0,12.6v22.5c0,2.8,2.2,5,5,5h15.4L31,31.5V18.8l-4-8V6z
			 M3.7,9.9l15.6-7.5C21.9,1.1,25,3.1,25,6v5.3l4,8v11.3l-9.4,7.5H5c-1.6,0-3-1.4-3-3V12.6C2,11.4,2.7,10.4,3.7,9.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Rosetta
};
